export const InstanceTemplates = {
  consoleOutputModal: require('core/instance/details/console/consoleOutput.modal.html'),
};
